import type { StoreType } from "./storeTypes"

import AdultIcon from "@bounce/assets/images/store-types/adult-store-icon.svg"
import BarIcon from "@bounce/assets/images/store-types/bar-icon.svg"
import BarberShopIcon from "@bounce/assets/images/store-types/barber-shop-icon.svg"
import BeautySaloonIcon from "@bounce/assets/images/store-types/beauty-saloon-icon.svg"
import BikeRentalIcon from "@bounce/assets/images/store-types/bike-shop-icon.svg"
import CafeIcon from "@bounce/assets/images/store-types/cafe-icon.svg"
import CarIcon from "@bounce/assets/images/store-types/car-icon.svg"
import ConvenienceStoreIcon from "@bounce/assets/images/store-types/convenience-store-icon.svg"
import DeliIcon from "@bounce/assets/images/store-types/deli-icon.svg"
import DessertShopIcon from "@bounce/assets/images/store-types/dessert-shop-icon.svg"
import DryCleanerIcon from "@bounce/assets/images/store-types/dry-cleaner-icon.svg"
import ElectronicsStoreIcon from "@bounce/assets/images/store-types/electronics-store-icon.svg"
import FitnessCenterIcon from "@bounce/assets/images/store-types/fitness-center-icon.svg"
import HairSalonIcon from "@bounce/assets/images/store-types/hair-salon-icon.svg"
import HardwareStoreIcon from "@bounce/assets/images/store-types/hardware-store-icon.svg"
import HotelIcon from "@bounce/assets/images/store-types/hotel-icon.svg"
import KaraokeIcon from "@bounce/assets/images/store-types/karaoke-icon.svg"
import LuggageStorageIcon from "@bounce/assets/images/store-types/luggage-storage-icon.svg"
import OfficeIcon from "@bounce/assets/images/store-types/office-icon.svg"
import OthersIcon from "@bounce/assets/images/store-types/other-icon.svg"
import PharmacyIcon from "@bounce/assets/images/store-types/pharmacy-icon.svg"
import PrintingStoreIcon from "@bounce/assets/images/store-types/print-shop-icon.svg"
import RestaurantIcon from "@bounce/assets/images/store-types/restaurant-icon.svg"
import RetailStoreIcon from "@bounce/assets/images/store-types/retail-store-icon.svg"
import SmokeShopIcon from "@bounce/assets/images/store-types/smoke-shop-icon.svg"
import SouvenirShopIcon from "@bounce/assets/images/store-types/souvenir-shop-icon.svg"
import StationaryStoreIcon from "@bounce/assets/images/store-types/stationary-store-icon.svg"
import TattooParlorIcon from "@bounce/assets/images/store-types/tattoo-parlor-icon.svg"
import WellnessIcon from "@bounce/assets/images/store-types/wellness-center-icon.svg"

export const StoreTypeIcons = {
  "Adult Store": AdultIcon,
  Bar: BarIcon,
  "Barber Shop": BarberShopIcon,
  "Beauty Salon": BeautySaloonIcon,
  "Bike Rental": BikeRentalIcon,
  Cafe: CafeIcon,
  "Car Rental": CarIcon,
  "Convenience Store": ConvenienceStoreIcon,
  Deli: DeliIcon,
  "Dessert Shop": DessertShopIcon,
  "Dry Cleaner": DryCleanerIcon,
  "Electronics Store": ElectronicsStoreIcon,
  "Fitness Center": FitnessCenterIcon,
  "Hair Salon": HairSalonIcon,
  "Hardware Store": HardwareStoreIcon,
  Hotel: HotelIcon,
  Karaoke: KaraokeIcon,
  "Luggage Storage": LuggageStorageIcon,
  Office: OfficeIcon,
  Pharmacy: PharmacyIcon,
  "Print Shop": PrintingStoreIcon,
  Restaurant: RestaurantIcon,
  "Retail Store": RetailStoreIcon,
  "Shipping Store": PrintingStoreIcon,
  "Smoke Shop": SmokeShopIcon,
  "Souvenir Shop": SouvenirShopIcon,
  "Stationary Store": StationaryStoreIcon,
  "Tattoo Parlor": TattooParlorIcon,
  "The UPS Store": OthersIcon,
  "Travel Agency": OthersIcon,
  "Wellness Center": WellnessIcon,
  Other: OthersIcon,
}

export const resolveStoreTypeIcon = (type: string | null | undefined) => {
  return !!type && type in StoreTypeIcons ? StoreTypeIcons[type as StoreType] : StoreTypeIcons.Other
}
